// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1pP88","label":"label-2ZYDA"};